import React, { useState } from "react";
import "./ForgotPassword.css";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { useMutation } from "@apollo/client";
import { FORGOT_PASSWORD } from "./queries";

export default function ForgotPassword() {
  const [forgotPassword] = useMutation(FORGOT_PASSWORD);

  const [submittedEmail, setSubmittedEmail] = useState(undefined);

  function handleSubmit(email) {
    forgotPassword({ variables: { email: email } }).then(() =>
      setSubmittedEmail(email)
    );
  }

  return (
    <div className="forgot-password-container">
      {submittedEmail === undefined ? (
        <>
          <h1 className="forgot-password-header">Forgot Password</h1>
          <div className="forgot-password-form-container">
            <ForgotPasswordForm onSubmit={handleSubmit} />
          </div>
        </>
      ) : (
        <div className="forgot-password-submitted">
          <p>Check your email to reset your password</p>
          <p>
            If there&apos;s a Gup&apos;s Corner account with{" "}
            <strong>{submittedEmail}</strong> you&apos;ll get a link in your
            inbox to reset your password.
          </p>
          <p>
            If you don&apos;t get the link, check your spam folder or{" "}
            <a href="/forgot-password">re-enter your email address</a>.
          </p>
        </div>
      )}
    </div>
  );
}
